var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectedmanagerReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.913,
    height: 36.265,
    viewBox: "0 0 28.913 36.265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701",
    transform: "translate(-47.121 -889.067)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 20.376,
    height: 27.716,
    rx: 0.928,
    transform: "translate(55.157 897.117)",
    fill: "#005637",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_693",
    "data-name": "Line 693",
    x2: 4.683,
    transform: "translate(58.405 902.129)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_694",
    "data-name": "Line 694",
    x2: 3.805,
    transform: "translate(69.831 902.129)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_695",
    "data-name": "Line 695",
    x2: 2.924,
    transform: "translate(58.405 903.638)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_696",
    "data-name": "Line 696",
    x2: 2.924,
    transform: "translate(61.903 903.638)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_697",
    "data-name": "Line 697",
    x2: 1.719,
    transform: "translate(58.405 905.953)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_698",
    "data-name": "Line 698",
    x2: 7.111,
    transform: "translate(60.727 905.953)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_699",
    "data-name": "Line 699",
    x2: 5.246,
    transform: "translate(68.324 905.953)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_700",
    "data-name": "Line 700",
    x1: 2.398,
    transform: "translate(71.172 908.225)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_701",
    "data-name": "Line 701",
    x1: 5.483,
    transform: "translate(65.036 908.225)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_702",
    "data-name": "Line 702",
    x1: 6.104,
    transform: "translate(58.405 908.225)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_703",
    "data-name": "Line 703",
    x1: 1.719,
    transform: "translate(71.85 913.141)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_704",
    "data-name": "Line 704",
    x1: 7.111,
    transform: "translate(64.137 913.141)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_705",
    "data-name": "Line 705",
    x1: 5.246,
    transform: "translate(58.405 913.141)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_706",
    "data-name": "Line 706",
    x2: 2.398,
    transform: "translate(58.405 910.869)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_707",
    "data-name": "Line 707",
    x2: 5.483,
    transform: "translate(61.456 910.869)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_708",
    "data-name": "Line 708",
    x2: 6.104,
    transform: "translate(67.465 910.869)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_709",
    "data-name": "Line 709",
    x2: 2.427,
    transform: "translate(66.472 915.413)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_710",
    "data-name": "Line 710",
    x2: 4.3,
    transform: "translate(69.269 915.413)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_711",
    "data-name": "Line 711",
    x2: 2.763,
    transform: "translate(58.405 915.413)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_712",
    "data-name": "Line 712",
    x2: 3.076,
    transform: "translate(62.113 915.413)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_713",
    "data-name": "Line 713",
    x1: 1.719,
    transform: "translate(71.85 919.957)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_714",
    "data-name": "Line 714",
    x1: 7.111,
    transform: "translate(64.137 919.957)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_715",
    "data-name": "Line 715",
    x1: 5.246,
    transform: "translate(58.405 919.957)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_716",
    "data-name": "Line 716",
    x2: 2.398,
    transform: "translate(58.405 917.685)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_717",
    "data-name": "Line 717",
    x2: 5.483,
    transform: "translate(61.456 917.685)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_718",
    "data-name": "Line 718",
    x2: 6.104,
    transform: "translate(67.465 917.685)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_719",
    "data-name": "Line 719",
    x2: 2.427,
    transform: "translate(66.472 922.229)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_720",
    "data-name": "Line 720",
    x2: 4.3,
    transform: "translate(69.269 922.229)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_721",
    "data-name": "Line 721",
    x2: 2.763,
    transform: "translate(58.405 922.229)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_722",
    "data-name": "Line 722",
    x2: 3.076,
    transform: "translate(62.113 922.229)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    width: 20.376,
    height: 27.716,
    rx: 0.928,
    transform: "translate(51.107 893.519)",
    fill: "#005637",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_723",
    "data-name": "Line 723",
    x2: 4.683,
    transform: "translate(54.355 898.531)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_724",
    "data-name": "Line 724",
    x2: 3.805,
    transform: "translate(65.781 898.531)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_725",
    "data-name": "Line 725",
    x2: 2.924,
    transform: "translate(54.355 900.039)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_726",
    "data-name": "Line 726",
    x2: 2.924,
    transform: "translate(57.853 900.039)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_727",
    "data-name": "Line 727",
    x2: 1.719,
    transform: "translate(54.355 902.355)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_728",
    "data-name": "Line 728",
    x2: 7.111,
    transform: "translate(56.677 902.355)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_729",
    "data-name": "Line 729",
    x2: 5.246,
    transform: "translate(64.274 902.355)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_730",
    "data-name": "Line 730",
    x1: 2.398,
    transform: "translate(67.122 904.627)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_731",
    "data-name": "Line 731",
    x1: 5.483,
    transform: "translate(60.986 904.627)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_732",
    "data-name": "Line 732",
    x1: 6.104,
    transform: "translate(54.355 904.627)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_733",
    "data-name": "Line 733",
    x1: 1.719,
    transform: "translate(67.8 909.543)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_734",
    "data-name": "Line 734",
    x1: 7.111,
    transform: "translate(60.087 909.543)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_735",
    "data-name": "Line 735",
    x1: 5.246,
    transform: "translate(54.355 909.543)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_736",
    "data-name": "Line 736",
    x2: 2.398,
    transform: "translate(54.355 907.271)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_737",
    "data-name": "Line 737",
    x2: 5.483,
    transform: "translate(57.406 907.271)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_738",
    "data-name": "Line 738",
    x2: 6.104,
    transform: "translate(63.415 907.271)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_739",
    "data-name": "Line 739",
    x2: 2.427,
    transform: "translate(62.422 911.815)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_740",
    "data-name": "Line 740",
    x2: 4.3,
    transform: "translate(65.219 911.815)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_741",
    "data-name": "Line 741",
    x2: 2.763,
    transform: "translate(54.355 911.814)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_742",
    "data-name": "Line 742",
    x2: 3.076,
    transform: "translate(58.063 911.814)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_743",
    "data-name": "Line 743",
    x1: 1.719,
    transform: "translate(67.8 916.359)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_744",
    "data-name": "Line 744",
    x1: 7.111,
    transform: "translate(60.087 916.359)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_745",
    "data-name": "Line 745",
    x1: 5.246,
    transform: "translate(54.355 916.359)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_746",
    "data-name": "Line 746",
    x2: 2.398,
    transform: "translate(54.355 914.086)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_747",
    "data-name": "Line 747",
    x2: 5.483,
    transform: "translate(57.406 914.086)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_748",
    "data-name": "Line 748",
    x2: 6.104,
    transform: "translate(63.415 914.086)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_749",
    "data-name": "Line 749",
    x2: 2.427,
    transform: "translate(62.422 918.63)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_750",
    "data-name": "Line 750",
    x2: 4.3,
    transform: "translate(65.219 918.63)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_751",
    "data-name": "Line 751",
    x2: 2.763,
    transform: "translate(54.355 918.63)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_752",
    "data-name": "Line 752",
    x2: 3.076,
    transform: "translate(58.063 918.63)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    width: 20.376,
    height: 27.716,
    rx: 0.928,
    transform: "translate(47.621 889.567)",
    fill: "#005637",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_753",
    "data-name": "Line 753",
    x2: 4.683,
    transform: "translate(50.442 893.519)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_754",
    "data-name": "Line 754",
    x2: 3.805,
    transform: "translate(61.867 893.519)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_755",
    "data-name": "Line 755",
    x2: 2.924,
    transform: "translate(50.442 895.027)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_756",
    "data-name": "Line 756",
    x2: 2.924,
    transform: "translate(53.939 895.027)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_757",
    "data-name": "Line 757",
    x2: 1.719,
    transform: "translate(50.442 897.343)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_758",
    "data-name": "Line 758",
    x2: 7.111,
    transform: "translate(52.763 897.343)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_759",
    "data-name": "Line 759",
    x2: 5.246,
    transform: "translate(60.36 897.343)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_760",
    "data-name": "Line 760",
    x1: 2.398,
    transform: "translate(63.208 899.615)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_761",
    "data-name": "Line 761",
    x1: 5.483,
    transform: "translate(57.072 899.615)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_762",
    "data-name": "Line 762",
    x1: 6.104,
    transform: "translate(50.442 899.615)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_763",
    "data-name": "Line 763",
    x1: 1.719,
    transform: "translate(63.886 904.531)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_764",
    "data-name": "Line 764",
    x1: 7.111,
    transform: "translate(56.173 904.531)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_765",
    "data-name": "Line 765",
    x1: 5.246,
    transform: "translate(50.441 904.531)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_766",
    "data-name": "Line 766",
    x2: 2.398,
    transform: "translate(50.441 902.259)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_767",
    "data-name": "Line 767",
    x2: 5.483,
    transform: "translate(53.492 902.259)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_768",
    "data-name": "Line 768",
    x2: 6.104,
    transform: "translate(59.502 902.259)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_769",
    "data-name": "Line 769",
    x2: 2.427,
    transform: "translate(58.508 906.803)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_770",
    "data-name": "Line 770",
    x2: 4.3,
    transform: "translate(61.306 906.803)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_771",
    "data-name": "Line 771",
    x2: 2.763,
    transform: "translate(50.441 906.802)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_772",
    "data-name": "Line 772",
    x2: 3.076,
    transform: "translate(54.149 906.802)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_773",
    "data-name": "Line 773",
    x1: 1.719,
    transform: "translate(63.886 911.346)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_774",
    "data-name": "Line 774",
    x1: 7.111,
    transform: "translate(56.173 911.346)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_775",
    "data-name": "Line 775",
    x1: 5.246,
    transform: "translate(50.441 911.346)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_776",
    "data-name": "Line 776",
    x2: 2.398,
    transform: "translate(50.441 909.074)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_777",
    "data-name": "Line 777",
    x2: 5.483,
    transform: "translate(53.492 909.074)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_778",
    "data-name": "Line 778",
    x2: 6.104,
    transform: "translate(59.502 909.074)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_779",
    "data-name": "Line 779",
    x2: 2.427,
    transform: "translate(58.508 913.618)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_780",
    "data-name": "Line 780",
    x2: 4.3,
    transform: "translate(61.306 913.618)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_781",
    "data-name": "Line 781",
    x2: 2.763,
    transform: "translate(50.441 913.618)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_782",
    "data-name": "Line 782",
    x2: 3.076,
    transform: "translate(54.149 913.618)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedmanagerReport);
export default __webpack_public_path__ + "static/media/SelectedmanagerReport.2e92120b45fa4ef0c4466fd76970397b.svg";
export { ForwardRef as ReactComponent };